import React from "react";

type InvoiceProps = {
  invoiceNo?: string;
  date?: string;
  time?: string;
  salesperson?: string;
};

const Invoice: React.FC<InvoiceProps> = ({
  invoiceNo = "15",
  date = "26/11/2025",
  time = "08:27 AM",
  salesperson = "admin",
}) => {
  return (
    <div
      style={{
        width: "180mm",
        margin: "auto",
        fontSize: "14px",
        color: "#000",
        padding: "10mm",
        fontFamily: "Arial, sans-serif",
        background: "#fff",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          border: "1px solid #000",
          backgroundColor: "#082E1F",
          color: "#CCA65B",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 24,
            fontWeight: "bold",
            backgroundColor: "#082E1F",
            padding: "8px 12px",
            flex: 1,
          }}
        >
          TAX INVOICE
        </div>
        <div
          style={{
            fontSize: 12,
            lineHeight: 1.6,
            padding: "8px 12px",
            width: 220,
            textAlign: "right",
          }}
        >
          <div>
            <strong>INVOICE NO:</strong> {invoiceNo}
          </div>
          <div>
            <strong>DATE:</strong> {date}
          </div>
          <div>
            <strong>TIME:</strong> {time}
          </div>
          <div>
            <strong>SALESPERSON:</strong> {salesperson}
          </div>
        </div>
      </div>

      {/* Company Info */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px 0",
          marginTop: 16,
        }}
      >
        <div
          style={{
            width: 100,
            height: 100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: 16,
            border: "1px solid #000",
            overflow: "hidden",
          }}
        >
          <img
            src="/static/media/Company Logo.33fc3395f3402e9f6693.png"
            alt="Logo"
            style={{ width: "90%", height: "90%", objectFit: "contain" }}
          />
        </div>
        <div>
          <div style={{ fontWeight: "bold", fontSize: 24, display: 'flex', justifyContent: 'center', alignItems: 'center', fontFamily: 'algerian' }}>
            BUDDHA JEWELLERY SYDNEY{" "}
            <span style={{ fontSize: 10 }}>EST: 2014</span>
          </div>
          <div >ADDRESS: 506 Princes Highway ROCKDALE NSW 2216</div>
          <div style={{ padding: 12, fontWeight: 'bold', width: '100%', display: "flex", justifyContent: 'center' }} >ABN: 2216 883 1874</div>
        </div>
      </div>

      {/* Customer Info */}
      <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #000" }}>
        <tbody>
          <tr>
            <td style={{ padding: "4px 8px", verticalAlign: "top" }}>
              <strong>Customer Name:</strong> ragim maskey
              <br />
              <strong>Contact Number:</strong> +61425212361
              <br />
              <strong>Email:</strong> maskeyragim@gmail.com
            </td>
            <td style={{ padding: "4px 8px", verticalAlign: "center", textAlign: "left" }}>
              <strong>Terms of Delivery:</strong> In-Store
            </td>
          </tr>
        </tbody>
      </table>

      {/* Items Table */}
      <table
        style={{
          border: "1px solid #000",
          borderCollapse: "collapse",
          width: "100%",
          tableLayout: "fixed",
          minHeight: 250,
        }}
      >
        <thead>
          <tr>
            {[
              "Code #",
              "Particulars",
              "Purity",
              "Gold Rate per gm",
              "Net Weight (gm)",
              "Wastage (gm)",
              "CutPiece (gm)",
              "Total Weight (gm)",
              "Making Charge",
              "Beads Stone",
              "Amount",
            ].map((heading, idx) => (
              <th
                key={idx}
                style={{
                  border: "1px solid #000",
                  padding: 6,
                  fontSize: 10,
                  textDecoration: "underline",
                  lineHeight: 1.2,
                  maxHeight: "2.4em",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  textAlign: "center",
                }}
              >
                {heading}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {[
              "1c",
              "gold wedding ring",
              "18k",
              "10.00",
              "21.00",
              "10.00",
              "10.00",
              "41.00",
              "10.00",
              "10.00",
              "$430.00",
            ].map((value, idx) => (
              <td
                key={idx}
                style={{
                  padding: 6,
                  borderLeft: "1px solid #000",
                  borderRight: "1px solid #000",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  lineHeight: 1.2,
                  maxHeight: "2.4em",
                }}
              >
                {value}
              </td>
            ))}
          </tr>
          {/* Empty rows */}
          {Array.from({ length: 5 }).map((_, idx) => (
            <tr key={idx}>
              {Array.from({ length: 10 }).map((_, i) => (
                <td
                  key={i}
                  style={{
                    padding: 6,
                    borderLeft: "1px solid #000",
                    borderRight: "1px solid #000",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    lineHeight: 1.2,
                    maxHeight: "2.4em",
                  }}
                >
                  &nbsp;
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Totals */}
      <div style={{ display: "flex" }}>
        {/* Terms */}
        <div style={{ marginTop: 20, width: '60%' }}>
          <h4 style={{ marginBottom: 6 }}>Terms and Conditions</h4>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <li>Test terms and conditions!!</li>
          </ul>
        </div>
        <table style={{ width: "50%", borderCollapse: "collapse" }}>
          {[
            ["Total", "$430.00"],
            ["GST (10%)", "$43.00"],
            ["Discount(0$)", "$0.00"],
            ["Grand Total", "$473.00", true],
          ].map(([label, value, isGrand], idx) => (
            <tr key={idx}>
              <td
                style={{
                  border: "1px solid #000",
                  padding: 6,
                  textAlign: "left",
                  backgroundColor: isGrand ? "#082E1F" : undefined,
                  color: isGrand ? "#CCA65B" : undefined,
                  fontWeight: isGrand ? "bold" : undefined,
                }}
              >
                {label}
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: 6,
                  textAlign: "right",
                  backgroundColor: isGrand ? "#082E1F" : undefined,
                  color: isGrand ? "#CCA65B" : undefined,
                  fontWeight: isGrand ? "bold" : undefined,
                }}
              >
                {value}
              </td>
            </tr>
          ))}
        </table>
      </div>
    </div>
  );
};

export default Invoice;
